import React from "react";
import MTBanner from "../../Componenets/MT5/MTBanner";
import Market from "../../Componenets/MTMarket/Market";
import { Assetes } from "../../Componenets/Mt5Assets/Assetes";
import Mt5Trade from "../../Componenets/Mt5Trade/Mt5Trade";
import MTCorp from "../../Componenets/WhyBBCorp/MTCorp";
import MtSlider from "../../Componenets/MtSlider/MtSlider";
import MTMobile from "../../Componenets/MTMobile/MTMobile";
import { NewAssts } from "../../Componenets/Mt5Assets/NewAssts";

const HeroBanner = () => {
  const cardData = [
    {
      heading: "MetaEditor",
      logo: "/Images/meta.png",
      description:
        "On MetaTrader 5, you can develop trading robots and technical indicators through the specialized MetaEditor tool. As the tool is linked with the platform, new programs will automatically appear in your MetaTrader 5 and can be executed instantly.",
    },
    {
      heading: "Hedging system",
      logo: "/Images/solid.png",
      description:
        "In MetaTrader 5 with BBCorp, you can experience trading using the hedging mode system. Hedging allows you to open multiple positions, even exact opposite positions, for a trading instrument.",
    },
    {
      heading: "Fundamental analysis",
      logo: "/Images/dogs.png",
      description:
        "Capture market opportunities with fundamental analysis tools on the MetaTrader 5, such as the built-in Economic Calendar. Keep abreast of the latest news events, expected market impacts and forecasts.",
    },
    {
      heading: "Indicators & analytical object tools",
      logo: "/Images/pie.png",
      description:
        "Enhance your trading experience with 38 built-in indicators, 22 analytical tools and 46 graphical objects when you trade financial instruments in the trading platform.",
    },
  ];
  return (
    <>
      <MTBanner />
      <Market />
      <Assetes />
      <Mt5Trade cardData={cardData} />
      {/* <MTMobile /> */}
      <NewAssts />
      <MTCorp />
      <MtSlider />

    </>
  );
};

export default HeroBanner;
